import { render, staticRenderFns } from "./UserDropdownMenu.vue?vue&type=template&id=d5ed5a64&"
import script from "./UserDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./UserDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports